// Contrato mínimo de un motor para el modelo de cohete. Lo implementa el catálogo de motores.

export interface MotorMassProfile {
  /** Diámetro exterior del motor (m). */
  readonly diameter: number;
  /** Longitud del motor (m). */
  readonly length: number;
  /** Masa total (carcasa + propelente restante) a `t` segundos de la ignición. */
  massAt(t: number): number;
}

/** Tolerancia de ajuste del diámetro del motor en su soporte (m): los diámetros son nominales. */
export const MOTOR_FIT_TOLERANCE = 0.5e-3;

export type MotorResolver = (motorId: string) => MotorMassProfile | undefined;
